import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropdown from '@s/Dropdown';

class UserSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            users: [],
        }
    }

    componentDidMount() {
        this.getUsers();
    }

    getUsers = () => {
        let req = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-API-Token': this.props.apiToken,
            },
        };

        return fetch(this.props.apiUrl + '/kiosks/'+this.props.listingSlug+'/users', req).then((res) => {
            if(res.status === 200) {
                return res.json();
            }
        }).then((res) => {
            let users = [...this.state.users];
            this.setState({users: users.concat(res.users)});
        }).catch((e) => {});
    }

    onUserSelect = (id) => {
        this.props.onUserSelect(id);
    }

    render() {
        return(
            <div className="input">
                <div className="input__horizontal">
                    <label className="input__label" htmlFor="userSelect">Kiosk User</label>
                    <Dropdown
                        id="userSelect"
                        className="input__control"
                        value={this.props.user}
                        options={this.state.users}
                        onChange={this.onUserSelect}
                        placeholder="Select a Kiosk User"
                    />
                </div>
            </div>
        )
    }
}

UserSelect.propTypes = {
    user: PropTypes.any,
    onUserSelect: PropTypes.func.isRequired,
    apiUrl: PropTypes.string.isRequired,
    listingSlug: PropTypes.string.isRequired,
}

UserSelect.defaultProps = {
}

export default UserSelect;
